<div *ngIf="pageDesignFlag">
    <div id="{{pageDesign.name}}" [ngStyle]="pageDesign.style">
  
        <div class="full-width">

            <!-- NON CUSTOM CODE SECTION -->
            <div *ngIf="!customDesign">
    
                <div *ngFor="let ele of pageDesign.element_flow" style="width: 100%;">
        
                    <div *ngIf="ele.type=='image'" id="img-div">
                        <img src="{{customService.imageUrl}}" [ngStyle]="ele.style">
                        <div class="img-overlay">
                            <div [innerHTML]="customLoader | sanitizeHtml"></div>
                        </div>
                    </div>
        
                    <p *ngIf="ele.type=='text'" [ngStyle]="ele.style" [innerHTML]="ele.text | sanitizeHtml"></p>
        
                    <button mat-raised-button *ngIf="ele.type=='button'" [ngStyle]="ele.style"
                    (click)="customService.triggerFunction(ele)">{{ele.text}}</button>

                </div>
            
            </div>
    
        </div>
  
    </div>
    
</div>